import React, { useState } from "react";
import DefaultNavbar from "./DefaultNavbar";
import DefaultFooter from "src/components/DefaultFooter";
import { Typography, Card, CardMedia, CardContent } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Grid from "@mui/material/Grid";
import Products from "./Products";
import Contact from "./Contact";
import background from "../../../assets/img/landing1.jpg";

const useStyles = makeStyles(() => ({
  root: {
    padding: "4px 6px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  input: {
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  rootCard: {
    maxWidth: 80,
    padding: 7,
    backgroundColor: "#ffffff",
  },
}));

const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export default function MainPage() {
  const classes = useStyles();
  const [searchitems, setSearchItems] = useState("");  

  const keyName = "name";
  return (
    <>
      <div className="absolute w-full z-20">
        <DefaultNavbar />
      </div>
      <main>
        <div className="relative pt-1 pb-10 flex content-center items-center justify-center h-screen">
          <div
            className="bg-landing-background bg-cover bg-center absolute top-0 w-full h-full"
            style={{
              backgroundImage: `linear-gradient(180deg, rgba(255,255,255,0) 0, rgba(0,0,0,0.6) 0),url(${background})`,
            }}
          />
          <div className="container max-w-8xl relative mx-auto">
            <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-1 ml-auto mr-auto text-center">
                {/* <H2 color="white">LabAsService</H2> */}
                <Typography variant="h2" color="white" className="mb-4">
                            LabAsService
                </Typography>
                <div className="text-gray-200">
                  <Paper component="form" className={classes.root}>
                    <InputBase
                      className={classes.input}
                      placeholder="Search ..."
                      inputProps={{ "aria-label": "search ..." }}
                      onChange={(event) => {
                        setSearchItems(event.target.value);
                      }}
                      value={searchitems}
                    />
                    <IconButton
                      type="submit"
                      className={classes.iconButton}
                      aria-label="search"
                    >
                      <SearchIcon />
                    </IconButton>
                  </Paper>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="pb-10 bg-gray-100 -mt-32">
          <div className="container max-w-7xl mx-auto px-4">
            <div className="flex flex-wrap relative z-50">
              <Grid container spacing={3} justify="center">
                {Products.filter((val) => {
                  if (searchitems == "") {
                    return val;
                  } else if (
                    val[keyName]
                      .toLowerCase()
                      .includes(searchitems.toString().toLowerCase())
                  ) {
                    return val;
                  }
                }).map((number) => {
                  return (
                    <div className="px-4 mt-12">
                      <CardMedia
                        component="img"
                        className={classes.rootCard}
                        alt=""
                        image={number.image}
                        sx={{ objectFit: 'contain' }}
                      />
                    </div>
                  );
                })}
                {Products.filter((val) =>
                  val[keyName]
                    .toLowerCase()
                    .includes(searchitems.toString().toLowerCase())
                ).length === 0 ? (
                  <Card>
                    <CardContent>
                      <div className="mr-auto text-center">
                        <Typography variant="h6" color="text.primary" className="mb-4">
                          LabAsService
                        </Typography>
                      </div>
                      <Contact />
                    </CardContent>
                  </Card>
                ) : (
                  ""
                )}
              </Grid>
            </div>
          </div>
        </section>
      </main>
      <DefaultFooter />
    </>
  );
}
